function CustomTextService($q) {
    'ngInject';

    return {
        BookingText(company, basketItem) {
            const deferred = $q.defer();
            company.$get('booking_text').then((emb) => {
                    return emb.$get('booking_text').then((details) => {
                            const msgs = [];
                            for (const detail of Array.from(details)) {
                                if (detail.message_type === 'Booking') {
                                    for (const name in basketItem.parts_links) {
                                        const link = basketItem.parts_links[name];
                                        if (detail.$href('item') === link) {
                                            if (msgs.indexOf(detail.message) === -1) {
                                                msgs.push(detail.message);
                                            }
                                        }
                                    }
                                }
                            }
                            return deferred.resolve(msgs);
                        }
                    );
                }
                , (err) => {
                    return deferred.reject(err);
                }
            );
            return deferred.promise;
        },

        confirmationText(company, total) {
            const deferred = $q.defer();
            company.$get('booking_text').then(emb =>
                    emb.$get('booking_text').then(details =>
                        total.getMessages(details, 'Confirm').then(msgs => deferred.resolve(msgs))
                    )

                , err => deferred.reject(err));
            return deferred.promise;
        }
    };

}

angular
    .module('BB')
    .service('CustomTextService', CustomTextService);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/custom_text.service.js